import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M4.481 14.039c.436.085.939.128 1.519.128h4c.58 0 1.083-.043 1.518-.128-.345-1.217-1.724-2.226-3.518-2.226-1.794 0-3.173 1.009-3.519 2.226Zm-1.073.332C3.584 12.3 5.662 10.813 8 10.813c2.338 0 4.416 1.486 4.591 3.558a.5.5 0 0 1-.356.522c-.647.191-1.392.274-2.235.274H6c-.843 0-1.588-.083-2.235-.274a.5.5 0 0 1-.357-.522Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M2.77 2.77c-.61.61-.937 1.613-.937 3.23v4c0 1.22.186 2.094.54 2.71.343.595.87.996 1.67 1.222l.005.002c.526.155 1.168.233 1.952.233h4c.783 0 1.425-.078 1.951-.233l.006-.002c.8-.226 1.327-.627 1.67-1.222.354-.616.54-1.49.54-2.71V6c0-1.617-.327-2.62-.937-3.23-.61-.61-1.613-.937-3.23-.937H6c-1.618 0-2.62.327-3.23.937Zm-.707-.707c.89-.89 2.22-1.23 3.937-1.23h4c1.716 0 3.047.34 3.937 1.23.89.89 1.23 2.221 1.23 3.937v4c0 1.3-.195 2.376-.674 3.209-.49.852-1.249 1.398-2.261 1.685-.646.19-1.39.273-2.232.273H6c-.842 0-1.586-.083-2.232-.273-1.013-.287-1.771-.833-2.262-1.685C1.027 12.376.833 11.3.833 10V6c0-1.716.34-3.047 1.23-3.937Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M8 5.167a1.89 1.89 0 0 0 0 3.78 1.89 1.89 0 0 0 0-3.78ZM5.113 7.053A2.884 2.884 0 0 1 8 4.167a2.89 2.89 0 0 1 0 5.78 2.89 2.89 0 0 1-2.887-2.894Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }